import React, { useState } from 'react'
import CodeHighlight from '../../components/CodeHighlight'
import { TbArrowBackUpDouble } from 'react-icons/tb'
import { motion } from 'framer-motion'
import { codeActive1, codeActive2, codeActive3, ExampleJs, MenuItemJs, MenuToggleJs, NavigationJs, styleCss } from './code'
import { Example } from './Bonus/Example'

function Active() {
    const [isActive, setIsActive] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const navItems = ['Home', 'About', 'Services', 'Contact'];

    const toggleActive = () => {
        setIsActive(!isActive);
    };

    return (
        <div className='w-screen bg-[#1e1e1e] text-white overflow-auto flex items-center justify-center h-screen'>
            <div className='w-full max-w-[1200px] no-scrollbar h-screen overflow-auto py-6 px-2'>
                <div className='flex flex-col gap-4'>
                    <div className='flex flex-col gap-4'>
                        <a href='/' className='text-2xl md:text-3xl flex items-center gap-2 text-neutral-200'>
                            <TbArrowBackUpDouble />
                            Actice Component</a>
                        <span>
                            Active Component is a component that is used to indicate the current state of a component. It is used to highlight the current state of a component. For example, a button that is active is highlighted with a different color or a tab that is active is highlighted with a different color.
                        </span>
                    </div>
                    <span>Simple Example Active Component : </span>
                    <CodeHighlight
                        code={codeActive1}
                        title="example.js"
                        language="javascript"
                    />
                    <span>Result : </span>
                    <div className='w-full min-h-[100px] py-3 rounded-lg flex items-center justify-center bg-neutral-700'>
                        <motion.div
                            onClick={toggleActive}
                            animate={{
                                scale: isActive ? 1 : 0.5,
                                backgroundColor: isActive ? "#2ecc71" : "#3498db",
                            }}
                            transition={{ type: "spring", stiffness: 300 }}
                            className='w-[150px] h-[150px] flex justify-center items-center rounded-lg cursor-pointer text-[20px]'
                        >
                            {isActive ? "Active" : "Inactive"}
                        </motion.div>
                    </div>

                    <span>Example Navbar Using Tailwind: </span>
                    <CodeHighlight
                        code={codeActive2}
                        title="example.js"
                        language="javascript"
                    />

                    <span>Result : </span>
                    <div className='w-full min-h-[100px] py-3 rounded-lg flex items-center justify-center bg-neutral-700'>
                        <div className='relative w-full flex gap-3 items-center justify-center'>
                            {navItems.map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => setActiveIndex(index)}
                                    className={`cursor-pointer pb-2 transition-all duration-300 relative ${activeIndex === index ? 'text-[#d7f93e]' : 'text-[#FFF]'}`}
                                >
                                    {item}
                                    {activeIndex === index && (
                                        <div
                                            layoutId="underline"
                                            className="absolute left-0 transition-all duration-300 right-0 h-[2px] bg-blue-500 bottom-0"
                                        />
                                    )}
                                </li>
                            ))}
                        </div>
                    </div>

                    <span>Example Navbar Using framer-motion: </span>
                    <CodeHighlight
                        code={codeActive3}
                        title="example.js"
                        language="javascript"
                    />
                    <span>Result : </span>
                    <div className='w-full min-h-[100px] py-3 rounded-lg flex items-center justify-center bg-neutral-700'>
                        <div className='relative w-full gap-3 flex items-center justify-center'>
                            {navItems.map((item, index) => (
                                <motion.li
                                    animate={{ color: activeIndex === index ? '#d7f93e' : '#FFF' }}
                                    key={index}
                                    onClick={() => setActiveIndex(index)}
                                    className='cursor-pointer pb-2 relative'
                                >
                                    {item}
                                    {activeIndex === index && (
                                        <motion.div
                                            layoutId="underline"
                                            className="absolute left-0 right-0 h-[2px] bg-blue-500 bottom-0"
                                            transition={{ duration: 0.3 }}
                                        />
                                    )}
                                </motion.li>
                            ))}
                        </div>

                    </div>

                    <span>The difference between the two codes above is not too much, but the results given are very visible, the underline which indicates the item that is moving is very visible, where using tailwind is very stiff even though the syntax being sorted remains the same. In the example with framer-motion underline the active item beautification looks smoother than with tailwind</span>

                    <span>Bonus Example : </span>
                    <div className='w-full relative min-h-[100px] overflow-hidden h-[450px] py-3 rounded-lg flex items-center justify-center bg-neutral-700'>
                        <Example />
                    </div>

                    <span>Source Code Bonus : </span>
                    <CodeHighlight
                        code={ExampleJs}
                        title="Example.js"
                        language="javascript"
                    />
                     <CodeHighlight
                        code={MenuItemJs}
                        title="MenuItem.js"
                        language="javascript"
                    />
                    <CodeHighlight
                        code={NavigationJs}
                        title="Navigation.js"
                        language="javascript"
                    />
                     <CodeHighlight
                        code={MenuToggleJs}
                        title="MenuToggle.js"
                        language="javascript"
                    />
                     <CodeHighlight
                        code={styleCss}
                        title="style.js"
                        language="css"
                    />
                </div>
            </div>
        </div>
    )
}

export default Active
